
import HstWebSocket from 'util/websocket'
import protSender from "util/protocol-sender"
import { MediaType, DisplayMode, Graphics } from "common/enums"
import MsgDispatcher from 'util/msg-dispatcher'
import { asyncWrapper, tracelog, colorToNumber, stringToColor, setResize } from 'common/common'
import logger from 'common/logger'
import eventRegistry from 'common/event-registry'
import PageStore from "whiteBoard/page-store"
import wbManager from "../white-board-manager"
import Render from 'whiteBoard/render/render'
import { WriteBoard } from 'whiteBoard/write/write'
import protocolSender from "util/protocol-sender"
import { promiseHandler } from "common/promise-handler"
import CanvasManager from './canvas/index'


const EDIT_WHITE_BOARD = 'edit_white_board'


/**
 * 只读的白板对象（仅接收白板数据）
 */
class Painter {
  constructor(params) {
    this.isClosing = false;

    // 页数据存储
    this.pageStore = null;

    this.originalData = null // 原始白板数据 宽高等

    // 是否是第一次获取全量数据
    this.firstFullData = true;

    // 缩放比例
    this.scaleRatio = 1;

    // 白板的原始宽高
    this.width = 0;
    this.height = 0;

    // Canvas父标签宽高
    this.parentWidth = 0;
    this.parentHeight = 0;

    // Canvas标签宽高
    this.canvasWidth = 0;
    this.canvasHeight = 0;

    // Canvas父标签
    this.parentEle = null;

    // Canvas标签
    this.canvasEle = null;

    // Canvas上下文
    this.canvasCtx = null;

    // 缓存全量数据
    this.sourcePaints = [];

    // 服务器发送的消息序列号
    this.msg_seq_id = null;

    // 本地发送消息序列号
    this.local_seq_id = this.msg_seq_id

    // 监听div大小变化
    this.intervalHandle = null;

    // 显示模式和参数
    this.displayMode = DisplayMode.DBWZ;
    this.displayParam = null;
    
    this.rotateAngle = 0 // 旋转角度

    this.bkColor = 'white' // 背景颜色

    // 保存构建参数
    this.userId = params.userId;
    this.mediaId = params.mediaId;
    this.streamId = params.streamId;
    this.streamToken = params.streamToken;
    this.streamServer = params.streamServer

    // 画布是否已经渲染
    this.canvasHasRendered = null

    // 注册媒体服务事件
    this.msgDispatcher = new MsgDispatcher();
    this.msgDispatcher.addMsgHandler(30002, this._editRes.bind(this))
    this.msgDispatcher.addMsgHandler(31000, this._dealAmendData.bind(this)) // 直线
    this.msgDispatcher.addMsgHandler(31002, this._dealAmendData.bind(this)) // 曲线
    this.msgDispatcher.addMsgHandler(30103, this._dealOtherData.bind(this)) // 鼠标点 翻页 旋转
    this.msgDispatcher.addMsgHandler(31004, this._dealAmendData.bind(this)) // 矩形 圆角矩形 椭圆
    this.msgDispatcher.addMsgHandler(31006, this._dealAmendData.bind(this)) // 文字
    
    this.msgDispatcher.addMsgHandler(31008, this._dealAmendData.bind(this)) // 图片
    this.msgDispatcher.addMsgHandler(30200, this._pageChangeHandle.bind(this)) // 切页
    this.msgDispatcher.addMsgHandler(30202, this._moveGraph.bind(this)) // 移动
    
    this.msgDispatcher.addMsgHandler(30000, this._heartBeat.bind(this))
    this.msgDispatcher.addMsgHandler(30004, this._dealFullData.bind(this))
    this.msgDispatcher.addMsgHandler(19005, this._processLoginResp.bind(this));

    this.state = null // 对象状态

    // 创建WebSocket连接
    this.websocket = new HstWebSocket({
      addrUrl: [this.streamServer],
      handler: this.msgDispatcher,
      opened: this._onWebsocketOpen.bind(this),
      closed: this._onWebsocketClosed.bind(this),
      error: this._onWebsocketError.bind(this)
    });

    return this
  }
  /**
   * 给普通元素添加onresize的方法的函数
   * @param {*} target 对应元素的父节点
   * @param {*} callback onresize 回调函数触发
   * @param {*} adapterFn 回调函数触发处理函数 （防抖等）
   */
  @setResize
  setResize (target, callback) {
  }

  /**
   * 登录接收通道响应
   * @param {*} msg 
   */
  @tracelog
  _processLoginResp(msg) {
    if (msg.result != 0) {
      logger.warn("Login white board receive channel failed!");
    } else {
      // protSender.sendGetWhiteBoardFullDataReq(this.websocket);
    }
  }

  /**
   * WebSocket建立成功
   */
  @tracelog
  _onWebsocketOpen() {
    protSender.sendLoginRecvChannelReq(this.websocket, {
      mediaType: MediaType.WHITE_BOARD,
      mediaId: "",
      streamId: this.streamId,
      streamToken: this.streamToken
    });
  }

  /**
   * WebSocekt关闭
   */
  @tracelog
  _onWebsocketClosed() {
    if (!this.isClosing) {
      if (this.websocket.reconnectNum < 10 ) {
        setTimeout(() => {
          this.websocket.reconnect()
        }, 1000)
      } else {
        // throw error  
        eventRegistry.trigger('onError', { code: 102, reason: 'whiteBoard restore failed'}) 
      }
  }
   
    // if (!this.isClosing) {
    //   asyncWrapper(()=>{eventRegistry.trigger("restoreWhiteBoard", {
    //     userId: this.userId,
    //     mediaId: this.mediaId,
    //     parentEle: this.parentEle,
    //     displayMode: this.displayMode,
    //     displayParam: this.displayParam})
    //   })
    //   this.close();
    // }
  }

  /**
   * WebSocket错误
   */
  @tracelog
  _onWebsocketError() {
  }
  /**
   * 设置Canvas父节点
   * @param {*} parentEle 
   */
  setParentElement(parentEle) {
    logger.log("Set parent element: " + parentEle);
    if (parentEle && !this.canvasHasRendered) {
      this.canvasHasRendered = true
      // 保存父节点
      this.parentEle = parentEle;

      this.canvasManager = new CanvasManager(this)
      
      this.canvasManager.mount(this.parentEle)
      // let { ctx } = this.canvasManager.getRenderCanvas()
      // // 获取渲染Canvas上下文
      // this.canvasCtx = ctx
      
      this.write = new WriteBoard(this, this.pageStore)

      // 循环监听DIV大小变化，FIXME：可能会有性能问题
      this.setResize(this.parentEle, (params) => {
        this._tryShowWhiteBoard()
      })
    } else {
      if (this.intervalHandle) {
        clearInterval(this.intervalHandle);
        this.intervalHandle = null;
      }
      this.parentEle.innerHTML = ''
      this.canvasHasRendered = false
    }
  }
  /**
   * 设置显示模式
   * @param {*} mode 
   * @param {*} param 
   */
  setDisplayMode(mode, param) {
    if (this.displayMode != mode // 显示模式改变
      || (mode == DisplayMode.DBSF && param && this.displayParam != param)) { // 等比缩放参数改变
      this.displayMode = mode;
      this.displayParam = param;
      this._showWhiteBoard();
    }
  }

  /**
   * div大小变化则重新渲染白板
   */
  _tryShowWhiteBoard(width, height) {
    this._showWhiteBoard();

    // 更新父节点宽高
    this.parentWidth = width;
    this.parentHeight = height;
  }

  /**
   * 渲染白板
   */
  _showWhiteBoard() {
    if (!this.parentEle) return;
    // 绘制图形
    if (this.displayMode == DisplayMode.DBWZ) {
      this.canvasManager.showWhiteBoardDbwz();
    } else if (this.displayMode == DisplayMode.DBSY) {
      this.canvasManager.showWhiteBoardDbsy();
    } else if (this.displayMode == DisplayMode.DBSF) {
      this.canvasManager.showWhiteBoardDbsf();
    } else {
      logger.error("Unknown display mode: " + this.displayMode);
    }
    this.canvasManager.setOrigin(this.rotateAngle)

    // 绘制背景图片
    if (this.pageStore.getFilePath()) {
      this.canvasManager.setBackgroundImage()
    } else { // fixed bug #2393
      this.canvasManager.setBackgroundColor(this.bkColor)
    }

    this.render._drawAllPaint();
  }

  preloadImage (boardInfo, boardData) {
    // 预加载背景图片
    if (this.pageStore.getFilePath()) {
      for (let i = 0; i < boardInfo.page; i++ ) {
        let fullPath = `${boardInfo.convert_file_path}/${i}.jpg`
        wbManager._getFileUrl(fullPath)
      }
    }
  }

  /**
   * 初始化canvas画板
   * @param {*} boardInfo 
   */
  _initCanvas (board) {
    let boardInfo = board[0].board
    this.width = boardInfo.width
    this.height = boardInfo.height
    this.originalData = boardInfo
    if (Object.prototype.hasOwnProperty.call(boardInfo, 'property')) {
      this.rotateAngle = boardInfo.property.rotate_angle
      this.bkColor = boardInfo.property.bk_color === 0 ? 'white' : stringToColor(boardInfo.property.bk_color)
      switch (this.rotateAngle) {
        case 0: 
        case 180: 
          this.width = boardInfo.width
          this.height = boardInfo.height
          break
        case 90: 
        case 270: 
          this.width = boardInfo.height
          this.height = boardInfo.width
      }
    }
    this.preloadImage(board[0].board, board)
  }
  /**
   * 修改/删除/新增 图元
   * @param {*} paintObj 
   */
  _dealAmendData (paintObj) {
    this._updateMsgSeq(paintObj);
    this.render.dealAmendData(paintObj)
  }

  /**
   * 页变化
   * @param {*} pageObj 
   */
  _pageChangeHandle (pageObj) {
    this._updateMsgSeq(pageObj);
    this.render.pageChange(pageObj)
  }

  /**
   * 移动图元
   * @param {*} paintObj 
   */
  _moveGraph (paintObj) {
    this._updateMsgSeq(paintObj);
    this.render.moveGraph(paintObj)
  }
  /**
   * 兼容数据协议  鼠标点 旋转 翻页
   * @param {*} paintObj 
   */
  _dealOtherData (paintObj) {
    this._updateMsgSeq(paintObj)
    // 云会议协议  翻页
    if (Object.prototype.hasOwnProperty.call(paintObj, 'cur_page')) {
      this._pageChangeHandle({
        page: {
          pid: paintObj.cur_page,
          action: 0
        },
        edit_id: paintObj.edit_id,
        type: 'page',
        seq_id: paintObj.seq_id
      })
    }
    // 旋转
    if (Object.prototype.hasOwnProperty.call(paintObj, 'rotate_angle')) {
      // 后续处理
      this._rotate({
        width: this.originalData.width,
        height: this.originalData.height,
        rotate_angle: paintObj.rotate_angle
      })
    }
    // 设置背景颜色
    if (Object.prototype.hasOwnProperty.call(paintObj, 'bk_color')) {
      this.canvasManager.setBackgroundColor(stringToColor(paintObj.bk_color))
    }
    if (Object.prototype.hasOwnProperty.call(paintObj, 'mouse_posx')) {
      this.render._drawMousePoint(paintObj)
    }
  }
  /**
   * 旋转
   */
  _rotate ({width, height, rotate_angle}) {
    switch (rotate_angle) {
      case 0: 
      case 180: 
        this.width = width
        this.height = height
        break
      case 90: 
      case 270: 
        this.width = height
        this.height = width
    }
    this.rotateAngle = rotate_angle
    this.canvasManager.setSize(this.width, this.height)
    this._showWhiteBoard()
  }

  // 编辑响应
  _editRes (data) {
    this.pageStore.editConfig.status = true
    this.pageStore.editConfig.id = data.edit_id
    this.canvasEle.style.cursor = "crosshair";
    eventRegistry.trigger(EDIT_WHITE_BOARD, 0, true)
  }

  /**
   * 关闭白板
   */
  @tracelog
  close() {
    logger.log("Close white board: " + this.mediaId)
    this.isClosing = true;

    // this.pageStore = null;
    this.msgDispatcher = null;

    if (this.intervalHandle) {
      clearInterval(this.intervalHandle);
      this.intervalHandle = null;
    }
   
    if (this.parentEle && this.canvasManager) {
      // fixed bug #2392  没有渲染的白板不需要移除
      this.canvasHasRendered && (this.parentEle.innerHTML = null)
      //this.parentEle = null;
      this.canvasManager = null;
    }

    if (this.websocket) {
      this.websocket.close();
      this.websocket = null;
    }
  }
  
  /**
   * 处理全量数据
   * @param {*} msg 
   */
  _dealFullData(msg) {
    // 有可能会有多个消息，先缓存
    this.sourcePaints = this.sourcePaints.concat(msg.data)
    // 全量数据同步完成
    if (msg.sync_end) {
      logger.log("Get white board full data complete.");
      this.pageStore = new PageStore(this.sourcePaints)
      this.render = new Render(this, this.pageStore)
      if (!this.sourcePaints[0].board) {
        logger.error("Invalid source paints: " + JSON.stringify(this.sourcePaints));
        this.sourcePaints = [];
        return;
      }
      this._initCanvas(this.sourcePaints)

      // 通知上层开始渲染
      if (this.firstFullData) {
        if (!wbManager.tryRestoreWhiteBoardRender(this.mediaId)) {
          eventRegistry.trigger("onRemoteMediaAdd", { 
            userId: null, 
            mediaType: MediaType.WHITE_BOARD, 
            mediaId: this.mediaId,
            mediaName: this.pageStore.getBoardName(),
            isDocument: !!this.pageStore.getFilePath(),
            totalPage: this.pageStore.getPageCount(),
            curPage: this.pageStore.getCurPage()
          });
        }
        this.firstFullData = false;
      }

      this.sourcePaints = [];
    }
    // this.msg_seq_id = msg.seq_id
  }
  _updateMsgSeq (msg) {
    this.msg_seq_id = msg.seq_id
  }

  /**
   * 检查是否有丢消息，如果消息序列号异常，需要重新拉取全量数据
   * @param {*} msg 
   */
  _checkMsgSeq(msg) {
    if (!this.msg_seq_id // 第一次收到心跳
      || (this.msg_seq_id !== null && msg.seq_id - this.msg_seq_id !== 1 || this.firstFullData)) { // 序列号不连续
      protSender.sendGetWhiteBoardFullDataReq(this.websocket);
    }
    this.msg_seq_id = msg.seq_id
    this.local_seq_id = this.msg_seq_id
  }

  /**
   * 心跳
   * @param {*} msg 
   */
  _heartBeat (msg) {
    this._checkMsgSeq(msg);
  }
    /**
   * 
   * @param {*} type 图型 
   * @param {*} params  图型数据
   * @param {*} action 1 新增 2 修改  3 删除
   */
   _sendGraphMsg (type, params, action) {
    let msg = {
      type: type,
      seq_id: ++this.local_seq_id,
      edit_id: this.pageStore.editConfig.id,
    }
    params.action = action
    msg[type] = params
    if (type === Graphics.LINE) {
      msg.id = 31000
    } else if(type === Graphics.CURVE) {
      msg.id = 31002
    } else if (type === Graphics.TEXT) {
      msg.id = 31006
    } else if (type === Graphics.GMOV) {
      delete params.action
      msg.id = 30202
    }
    protocolSender.sendGraphMsg(this.websocket, msg)
  }
  /**
   * 清空白板
   */
  clear () {
    let params = {
      curPage: this.pageStore.getCurPage(),
      edit_id: this.pageStore.editConfig.id,
      // seq_id: this.msg_seq_id + 1,
      action: 3
    }
    protocolSender.sendPageInfoMsg(this.websocket, params)
    this.pageStore.revokeStack = []
    this.pageStore.restoreStack = []
  }
  // 选择线型大小
  brushSize (size) {
    // 没有输入参数 获取值
    if (size === undefined) {
      return this.pageStore.brush_size
    }
    this.pageStore.brush_size = parseInt(size) || this.pageStore.brush_size
  }
  // 选择颜色
  brushColor (color) {
    if (color === undefined) {
      return stringToColor(this.pageStore.color)
    }
    this.pageStore.color = colorToNumber(color) || this.pageStore.color
  }
  // 选择图形
  toolType (shape) {
    if (shape === undefined) {
      return this.pageStore.shape
    }
    this.pageStore.shape = shape || this.pageStore.shape
  }
  _transrate (stack1, stack2) {
    let paint = stack1.pop();
    if(!paint) return
    let graphType = paint.type
    let pageData = this.pageStore.findPagePaints(paint[graphType].pid);
    let movePaint = this.pageStore.findPaintByGid(pageData, paint[graphType].gid)
    // 当前找不到 则是恢复删除的线段 用原本保存的值
    paint = movePaint || paint
    if (paint[graphType].action === 1 || paint[graphType].action === 2) {
      this._sendGraphMsg(graphType, paint[graphType], 3)
      stack2.push(paint);
    } else if (paint[graphType].action === 3) {
      this._sendGraphMsg(graphType, paint[graphType], 1)
      stack2.push(paint);
    }
  }
  // 撤销
  revoke () {
    this._transrate(this.pageStore.revokeStack, this.pageStore.restoreStack)
  }
  // 恢复
  restore () {
    this._transrate(this.pageStore.restoreStack, this.pageStore.revokeStack)
  }
   /**
   * 是否开启编辑
   */
  edit (isEdit) {
    if (isEdit === undefined) {
      return this.pageStore.editConfig.status
    } else {
      if(isEdit) {
        let params = {
          id: 30001
        }
        this.websocket.send(JSON.stringify(params))
        return promiseHandler(EDIT_WHITE_BOARD)
      } else {
        this.pageStore.editConfig.status = false
        return Promise.resolve(false)
      }
    }
   
  }
  page (num) {
    if (num === undefined) {
      return this.pageStore.getCurPage()
    }
    // 页面超出限制
    if(num >= this.pageStore.getPageCount() || num < 0 ) return logger.warn('page number is not reasonable')
    let params = {
      curPage: num,
      edit_id: this.pageStore.editConfig.id,
      // seq_id: this.msg_seq_id + 1,
      action: 0
    }
    protocolSender.sendPageInfoMsg(this.websocket, params)
  }
}

export default Painter